var _circle, _circle2, _path, _path2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCirclesTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 144.001,
    r: 45.2237,
    stroke: "#323946",
    strokeWidth: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 144,
    r: 69.8553,
    stroke: "#323946",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M238.487 144C238.487 196.184 196.184 238.487 144.001 238.487C91.8169 238.487 49.5137 196.184 49.5137 144C49.5137 91.8164 91.8169 49.5132 144.001 49.5132C196.184 49.5132 238.487 91.8164 238.487 144Z",
    stroke: "#323946",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.119 144C263.119 209.788 209.788 263.119 144 263.119C78.213 263.119 24.8818 209.788 24.8818 144C24.8818 78.213 78.213 24.8818 144 24.8818C209.788 24.8818 263.119 78.213 263.119 144Z",
    stroke: "#323946",
    strokeWidth: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 144,
    cy: 144,
    r: 143.75,
    stroke: "#323946",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesTwo);
export default __webpack_public_path__ + "static/media/Circles-Two.cfd32687b3bf3814295d5769a851a5df.svg";
export { ForwardRef as ReactComponent };